import React from "react";
import { useTranslation } from "react-i18next";
import {
    StyledLabel,
    StyledTextInput,
    StyledSelectInput,
} from "@aureskonnect/react-ui";
import { AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";
import PhoneInput from "react-phone-input-2";

import store, { setIsEdited } from "../store";

import { CustomCardBody } from "@components/Common/CustomCardStyled";
import { roles, emailMatchWord } from "@constants/index";
import { useSnapshot } from "valtio";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "antd/dist/antd.css";
import "react-phone-input-2/lib/style.css";

export function CreateEmployeeBody({ data }: any) {
    const { t } = useTranslation();
    const { emails } = useSnapshot(store);

    return (
        <CustomCardBody
            className={`pl-3 pr-5 `}
            style={{
                maxHeight: "470px",
                overflowY: " auto",
            }}
        >
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel htmlFor="text" className="required__clz mt-3">
                    {t("Role")}
                </StyledLabel>
                <StyledSelectInput
                    options={roles.map((el: any) => {
                        return { ...el, label: t(el.label) };
                    })}
                    autoComplete="off"
                    placeholder={`${t("Select")}…`}
                    value={
                        data.role === ""
                            ? null
                            : {
                                  label: t(data.role),
                                  value: data.role,
                              }
                    }
                    onChange={(e: any) => {
                        data.setRole(e.value);
                        data.setInputRole(false);
                        setIsEdited(true);
                    }}
                    noOptionsMessage={() => t("No options")}
                    name={t("role")}
                    autoFocus
                    className={classnames("", {
                        invalid__clz: data.inputRole,
                    })}
                />
                {data.inputRole ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please chose a role")}
                    </div>
                ) : null}
            </AvGroup>
            <span className="d-flex justify-content-between">
                <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                    <StyledLabel className="required__clz mt-3" htmlFor="name">
                        {t("Name")}
                    </StyledLabel>
                    <StyledTextInput
                        autocomplete="off"
                        id="name"
                        name="name"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            data.setLastName(e.target.value);
                            data.setInputLastName(false);
                            setIsEdited(true);
                        }}
                        value={data.lastName}
                        className={classnames("", {
                            invalid__clz: data.inputLastName,
                        })}
                    />
                    {data.inputLastName ? (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.25rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                            }}
                        >
                            {t("Please enter a name")}
                        </div>
                    ) : null}
                </AvGroup>
                <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                    <StyledLabel className="required__clz mt-3" htmlFor="name">
                        {t("FirstName")}
                    </StyledLabel>
                    <StyledTextInput
                        autocomplete="off"
                        id="firstName"
                        name="firstName"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            data.setFirstName(e.target.value);
                            data.setInputFirstName(false);
                            setIsEdited(true);
                        }}
                        value={data.firstName}
                        className={classnames("", {
                            invalid__clz: data.inputFirstName,
                        })}
                    />
                    {data.inputFirstName ? (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.25rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                            }}
                        >
                            {t("Please enter a first name")}
                        </div>
                    ) : null}
                </AvGroup>
            </span>
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Email")}
                </StyledLabel>
                <StyledTextInput
                    autocomplete="off"
                    id="email"
                    name="email"
                    placeholder={t("Write")}
                    type="email"
                    onChange={(e: any) => {
                        const emailValue = e.target.value;
                        data.setEmailExist(
                            emails[data.editedData.shopId] !== undefined &&
                                emails[data.editedData.shopId].includes(
                                    emailValue
                                )
                        );
                        if (
                            emailValue !== "" &&
                            !emailValue.match(emailMatchWord)
                        ) {
                            data.setEmailInvalid(true);
                        } else {
                            data.setEmailInvalid(false);
                        }
                        data.setEmail(emailValue);
                        data.setInputEmail(false);
                        setIsEdited(true);
                    }}
                    value={data.email}
                    className={classnames("", {
                        invalid__clz:
                            data.inputEmail ||
                            data.isEmailExist ||
                            data.isEmailInvalid,
                    })}
                />
                {data.inputEmail ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter email")}
                    </div>
                ) : null}
                {data.isEmailExist && !data.inputEmail ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("This email address is already in use")}
                    </div>
                ) : null}
                {data.isEmailInvalid &&
                !data.inputEmail &&
                !data.isEmailExist ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Invalid email address")}
                    </div>
                ) : null}
            </AvGroup>
            <AvGroup className={`${data.isConsult ? "pe-none__clz" : ""}`}>
                <StyledLabel className="required__clz mt-3" htmlFor="name">
                    {t("Phone number")}
                </StyledLabel>

                <PhoneInput
                    buttonClass="ctl_btn_firstPhoneNumber"
                    inputClass="ctl_inp_firstPhoneNumber"
                    country="fr"
                    value={data.phoneNumber}
                    onChange={(e: any, country: any) => {
                        data.setCode(country.dialCode);
                        data.setPhoneNumber(e);
                        data.setInputPhoneNumber(false);
                        setIsEdited(true);
                    }}
                    placeholder={t("Saisir")}
                />
                {data.inputPhoneNumber ? (
                    <div
                        style={{
                            width: "100%",
                            marginTop: "0.25rem",
                            fontSize: "80%",
                            color: "#f46a6a",
                        }}
                    >
                        {t("Please enter phone number")}
                    </div>
                ) : null}
            </AvGroup>
        </CustomCardBody>
    );
}
